// src/forms/html_element_helpers/process_bad_response.js

import { return_error_clear_form_loading_state } from '../../forms/shared_form_ux_functions';
import {
    showRedBorderRequiredFieldsMissingValues
} from '../../helpers/form_validation';
import {
    form_input_types_string,
    default_selectors,
    at_least_one_required_identifier_fields,
    phone_number_fields
} from '../../helpers/static_vars';

/**
 * @param {Response|Object} response  – fetch Response or already‐parsed JSON with `error_code`
 * @param {HTMLElement} form_container
 * @param {string} error_container_selector  – not used here but kept for signature
 * @param {Object} data_hub_instance
 */
export async function process_bad_form_response(
    response,
    form_container = default_selectors.form_container_selector,
    error_container_selector = default_selectors.error_container_selector,
    data_hub_instance = window?.data_hub
) {
    // 1) parse JSON if it’s a real fetch Response
    let error_data = response;
    if (response instanceof Response) {
        try {
            error_data = await response.json();
        } catch (e) {
            return return_error_clear_form_loading_state(
                form_container,
                'process_bad_form_response: JSON parse failed',
                'Error submitting form. Please try again later.',
                data_hub_instance
            );
        }
    }

    const code = error_data?.error_code;
    if (!code) {
        return return_error_clear_form_loading_state(
            form_container,
            'process_bad_form_response: missing error_code',
            'Error submitting form. Please try again later.',
            data_hub_instance
        );
    }

    // 2) user-facing messages
    const messages = {
        missing_user_identifier: 'Please provide your email address or phone number.',
        missing_user_object: "Form data wasn't submitted correctly. Please try again.",
        missing_recipient_identifier: 'Please provide your email address or phone number.',
        bad_email_verify: 'Your email address was invalid. Please re-check and try again.',
        missing_email: 'Please provide your email address.',
        missing_phoneNumber: 'Your phone number was invalid or missing. Please re-check and try again.',
        error_formatting_user_data: 'There was an error processing your data. Please contact support.'
    };
    const userMessage = messages[code] || 'Error submitting form. Please try again later.';

    // 3) if it’s email‐bad, clear it out of your data_hub scope
    if (code === 'bad_email_verify' || code === 'missing_email') {
        if (data_hub_instance?.user_data) delete data_hub_instance.user_data.email;
        if (window.data_hub_user_data) delete window.data_hub_user_data.email;
    }

    // 4) if it’s phone‐bad, clear all your phone fields
    if (code === 'missing_phoneNumber') {
        phone_number_fields
            .forEach(phone => {
                if (data_hub_instance?.user_data) delete data_hub_instance.user_data[phone];
                if (window.data_hub_user_data) delete window.data_hub_user_data[phone];
            });

    }

    // 5) highlight _all_ your identifier inputs (blank or not)
    const allInputs = form_container.querySelectorAll(form_input_types_string);

    showRedBorderRequiredFieldsMissingValues(allInputs, at_least_one_required_identifier_fields);

    // 6) force‐red‐border on the specific field(s) idk why show red border isnt working.
    if (code === 'bad_email_verify' || code === 'missing_email') {
        form_container
            .querySelectorAll('input[name="email"], input#email')
            .forEach(el => changeElementErrorStatus(el, true));
    }
    if (code === 'missing_phoneNumber') {
        at_least_one_required_identifier_fields
            .filter(k => k.toLowerCase().includes('phone'))
            .forEach(name => {
                form_container
                    .querySelectorAll(`input[name="${name}"], input#${name}`)
                    .forEach(el => changeElementErrorStatus(el, true));
            });
    }

    // 7) finally, tear down the spinner/overlay & show your error popover
    return return_error_clear_form_loading_state(
        form_container,
        code,         // internal
        userMessage,  // external (shown in popover)
        data_hub_instance
    );
}
